import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[clickOutside]',
})
export class ClickOutsideDirective {
  @Output() clickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: EventTarget | null): void {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement as Node | null);
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}